import React, {Component} from 'react';

class Orgs extends Component {
    render() {
        return (
            <>
                <div className="content orgs">
                    <h1 className="page-title">
                        Manage Organizations
                    </h1>
                </div>
            </>
        )
    }
}

export default Orgs;
